import { Osoba } from 'src/app/lookups/osoba/osoba';
import { BaseEntity } from 'yt-ng-framework';

export class Zaposleni extends Osoba {
    constructor(){
        super();
    }
    OsobaID: number = null;
    DatumRodj: Date = null;
    MestoRodjID: number = null;
    BracniStatusID: number = null;
    BrojLk: string = null;
    LboBroj: string = null;
    NacijaID: number = null;
    VeroispovestID: number = null;
    VerskiPraznikID: number = null;
    StambenoPitanjeReseno: boolean = null;
    BrojClanovaPorodice: number = null;
    IzdrzavaClanovaPorodice: number = null;
    RegulisanaVojnaObaveza: boolean = null;
    SamohraniRoditelj: boolean = null;
    Napomena: string = null;
    OrgJedID: number= null;
    NazivUlice: string = null;
    Broj: string = null;
    PodBroj: string = null;
    MestoID: number = null;
    MesnaZajedID: number = null;
    StigaoDatum: Date = null;
    OtisaoDatum: Date = null;
    RadnoMestoID: number = null;
    StatusRoID: number = null;

    Deserialize(input: any){
        this.ID = input.ID;
        this.Ime = input.Ime;
        this.Prezime = input.Prezime;
        this.Devojacko = input.Devojacko;
        this.ImeOca = input.ImeOca;
        this.Jmbg = input.Jmbg;
        this.OsobaID = input.OsobaID;
        this.PolID = input.PolID;
        this.DatumRodj = input.DatumRodj;
        this.MestoRodjID = input.MestoRodjID;
        this.BracniStatusID = input.BracniStatusID;
        this.BrojLk = input.Brojlk;
        this.LboBroj = input.LboBroj;
        this.NacijaID = input.NacijaID;
        this.VeroispovestID = input.VeroispovestID;
        this.VerskiPraznikID = input.VerskiPraznikID;
        this.StambenoPitanjeReseno = input.StambenoPitanjeReseno;
        this.BrojClanovaPorodice = input.BrojClanovaPorodice;
        this.IzdrzavaClanovaPorodice = input.IzdrzavaClanovaPorodice;
        this.RegulisanaVojnaObaveza = input.RegulisanaVojnaObaveza;
        this.SamohraniRoditelj = input.SamohraniRoditelj;
        this.Napomena = input.Napomena;
        this.OrgJedID = input.OrgJedID;
        this.NazivUlice = input.NazivUlice;
        this.Broj = input.Broj;
        this.PodBroj = input.PodBroj;
        this.MestoID = input.MestoID;
        this.MesnaZajedID = input.MesnaZajedID;
        this.StigaoDatum = input.StigaoDatum;
        this.OtisaoDatum = input.OtisaoDatum;
        this.RadnoMestoID = input.RadnoMestoID;
        this.StatusRoID = input.StatusRoID;
        return this;
    }

    Serialize(input: Zaposleni){
        return input;
    }
}